import { DELETION_REASON_FIELDS } from 'routes/App/JobsAdmin/Jobs/JobWorkflowForm/constants'
import { UnitTree } from 'types/common'

export type Preview = {
  title: string
  short_name: string
  value: string
  type: string
}

export type User = {
  avatar?: string
  id: number
  name: string
  type?: string
}

export type Task = {
  id: number
  title: string
  state: string
  duplicated: boolean
  duplicable: boolean
  assigned_users: Array<User>
  assigned_user_groups: Array<User>
  media?: string
  modified_by: Array<User>
  locuses_and_groups: { groups: Array<UnitTree>; no_groups: Array<UnitTree> }
  needs_locus: boolean
  needs_locus_group: boolean
  original_task_id: number
  position: number
  preview_inputs: Array<Preview>
}

export type StatusCount = {
  completed: number
  in_progress: number
  not_started: number
  [key: string]: number
}

export interface Schedule {
  endDate?: string
  endDateAfterNumber?: number
  endDateAfterTerm?: string
  repeatBy?: string
  frequency?: number
  weekOrdinalNumber?: number
  dayOfWeek?: string
  daysOfWeek?: string[]
  daysOfMonth?: string
  endDateOnDate?: Date
}

export type Job = {
  id: number
  number: number
  title: string
  end_date: string
  end_date_time: string
  state: string
  overdue: boolean
  tasks: Array<Task>
  assigned_users: Array<User>
  assigned_user_groups: Array<User>
  created_by: User
  created_by_trigger_rule: boolean
  modified_by: Array<User>
  media: string
  tasks_completed_count: number
  tasks_total_count: number
  job_series_id: number
  preview_inputs: Array<Preview>
  site: { id: number; name: string }
  locuses_and_groups: { groups: Array<UnitTree>; no_groups: Array<UnitTree> }
  needs_deletion_reason: boolean
  needs_locus: boolean
  needs_locus_group: boolean
  start_date: string
  schedule: Schedule
  start_date_time: string
  created_date_time: string
  completed_date_time: string
  is_future: boolean
  deletion_reason_type: DELETION_REASON_FIELDS
  date_deleted: string
}

export enum Colors {
  blue = 'blue',
  yellow = 'yellow',
  green = 'green',
}
